import PropTypes from 'prop-types';
import React, { createContext, useContext, useMemo } from 'react';
import { ErrorPage } from '../components/ErrorPage';

export const InteractionsContext = createContext(undefined);

export function InteractionsProvider({
  children,
  client,
  currentEmployee,
  isClientsDrawer,
  provider,
}) {
  const value = useMemo(() => ({
    client,
    currentEmployee,
    isClientsDrawer,
    provider,
  }), [client, currentEmployee, isClientsDrawer, provider]);

  if (!client?.id || !currentEmployee?.id || !provider?.id) {
    // eslint-disable-next-line no-console
    console.error('StructuredInteractions: missing required context.\n', {
      clientId: client?.id,
      currentEmployeeId: currentEmployee?.id,
      providerId: provider?.id,
    });
    return <ErrorPage />;
  }

  return (
    <InteractionsContext.Provider value={value}>
      {children}
    </InteractionsContext.Provider>
  );
}

InteractionsProvider.propTypes = {
  children: PropTypes.node.isRequired,
  client: PropTypes.shape({ id: PropTypes.string }),
  currentEmployee: PropTypes.shape({ id: PropTypes.string }),
  isClientsDrawer: PropTypes.bool,
  provider: PropTypes.shape({ id: PropTypes.string }),
};

InteractionsProvider.defaultProps = {
  client: undefined,
  currentEmployee: undefined,
  isClientsDrawer: false,
  provider: undefined,
};

export function useClient() {
  const value = useContext(InteractionsContext);
  return value?.client;
}

export function useCurrentEmployee() {
  const value = useContext(InteractionsContext);
  return value?.currentEmployee;
}

export function useProvider() {
  const value = useContext(InteractionsContext);
  return value?.provider;
}

export function useIsClientsDrawer() {
  const value = useContext(InteractionsContext);
  return value?.isClientsDrawer ?? false;
}
